function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_1"
});

var SvgIconCcVisaColor = function SvgIconCcVisaColor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 69.388 43.575",
    style: {
      enableBackground: "new 0 0 69.388 43.575"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    id: "cc-visa--color"
  }, React.createElement("path", {
    style: {
      fill: "#0E4595"
    },
    d: "M58.113,19.275l-0.334-1.563c-0.249,0.68-0.683,1.777-0.655,1.729c0,0-1.557,4.015-1.965,5.063 h4.097C59.059,23.599,58.113,19.275,58.113,19.275z"
  }), React.createElement("path", {
    style: {
      fill: "#0E4595"
    },
    d: "M65.688,0H3.7C1.656,0,0,1.656,0,3.7v36.175c0,2.043,1.656,3.7,3.7,3.7h61.987 c2.043,0,3.7-1.657,3.7-3.7V3.7C69.388,1.656,67.73,0,65.688,0z M13.78,30.893l-4.368-15.66c-1.534-0.859-3.264-1.568-5.23-2.045 l0.063-0.377h7.96c1.073,0.039,1.939,0.383,2.237,1.529l1.695,8.15c0.018,0.053,0.046,0.107,0.063,0.16l0.515,2.51l4.834-12.35 h5.228l-7.771,18.076L13.78,30.893z M25.738,30.92l3.086-18.109h4.937L30.673,30.92H25.738z M39.193,31.135 c-2.215-0.021-4.347-0.461-5.499-0.967l0.692-4.054l0.636,0.288c1.621,0.676,2.672,0.951,4.647,0.951 c1.419,0,2.941-0.555,2.953-1.77c0.01-0.793-0.637-1.358-2.559-2.246c-1.873-0.866-4.352-2.318-4.325-4.921 c0.03-3.52,3.465-5.978,8.344-5.978c1.913,0,3.446,0.395,4.424,0.762l-0.67,3.926l-0.441-0.21c-0.911-0.366-2.08-0.719-3.694-0.694 c-1.934,0-2.827,0.805-2.827,1.559c-0.012,0.848,1.046,1.406,2.771,2.246c2.848,1.291,4.163,2.859,4.146,4.92 C47.751,28.707,44.382,31.135,39.193,31.135z M60.625,30.91c0,0-0.453-2.08-0.601-2.715c-0.72,0-5.756-0.007-6.323-0.007 c-0.19,0.489-1.038,2.722-1.038,2.722h-5.185l7.332-16.598c0.52-1.18,1.404-1.502,2.585-1.502h3.815l3.995,18.1H60.625z"
  }), React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "28.824,12.811 25.738,30.92 30.673,30.92 33.761,12.811  "
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M43.645,20.027c-1.725-0.84-2.782-1.398-2.771-2.246c0-0.754,0.894-1.559,2.827-1.559 c1.614-0.024,2.783,0.328,3.694,0.694l0.441,0.21l0.67-3.926c-0.978-0.367-2.511-0.762-4.424-0.762 c-4.879,0-8.313,2.458-8.344,5.978c-0.026,2.603,2.452,4.055,4.325,4.921c1.922,0.888,2.568,1.453,2.559,2.246 c-0.012,1.215-1.534,1.77-2.953,1.77c-1.976,0-3.026-0.275-4.647-0.951l-0.636-0.288l-0.692,4.054 c1.152,0.506,3.284,0.945,5.499,0.967c5.188,0,8.558-2.428,8.597-6.188C47.808,22.887,46.492,21.318,43.645,20.027z"
  }), React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "55.158,24.506 55.159,24.504 55.158,24.504  "
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M57.396,12.811c-1.181,0-2.065,0.322-2.585,1.502L47.479,30.91h5.185c0,0,0.848-2.232,1.038-2.722 c0.567,0,5.604,0.007,6.323,0.007c0.147,0.635,0.601,2.715,0.601,2.715h4.581l-3.995-18.1H57.396z M55.158,24.506v-0.002h0.001 c0.408-1.048,1.965-5.063,1.965-5.063c-0.027,0.049,0.406-1.049,0.655-1.729l0.334,1.563c0,0,0.945,4.323,1.143,5.229h-4.097 C55.158,24.504,55.158,24.506,55.158,24.506z"
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M21.548,12.811l-4.834,12.35l-0.515-2.51c-0.017-0.053-0.045-0.107-0.063-0.16l0.036,0.172 c-1.161-2.971-3.464-5.582-6.761-7.43l4.368,15.66l5.224-0.006l7.771-18.076H21.548z"
  }), React.createElement("path", {
    style: {
      fill: "#F2AE14"
    },
    d: "M16.137,22.49l-1.695-8.15c-0.298-1.146-1.164-1.49-2.237-1.529h-7.96l-0.063,0.377 c1.967,0.477,3.696,1.186,5.23,2.045l-0.05-0.179C12.438,16.594,15.186,19.643,16.137,22.49z"
  }), React.createElement("path", {
    style: {
      fill: "#F2AE14"
    },
    d: "M16.173,22.662l-0.036-0.172c-0.951-2.848-3.699-5.896-6.774-7.437l0.05,0.179 C12.709,17.08,15.012,19.691,16.173,22.662z"
  })), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconCcVisaColor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-cc-visa--color.99d30172.svg";
export { ForwardRef as ReactComponent };